import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { changeLanguage } from 'i18next';
import { setChannel } from '../../../Reducers/channelReducer';
import { useDispatch } from 'react-redux';
import "./DropdownButton.css"

const DropdownButton = ({ channelList }) => {
    const [currentChannel, setCurrentChannel] = useState({});

    const dispatch = useDispatch();

    useEffect(() => {
        const channel = channelList.find(item => item.lang.slice(0, 2) === localStorage.getItem('i18nextLng').slice(0, 2));
        if (channel) {
            setCurrentChannel(channel);
            dispatch(setChannel(channel));
            changeLanguage(channel.lang);
        }
    }, [channelList])

    const changeChannel = (channel) => {
        setCurrentChannel(channel);
        dispatch(setChannel(channel));
        changeLanguage(channel.lang);
    }

    return (
        <>
            <Dropdown className="header-link d-none d-md-flex">
                <Dropdown.Toggle variant="primary" className="d-flex align-items-center globe-btn">
                    <i className="bi bi-flag-fill" style={{ fontSize: '12px' }}></i>
                    <span className="text-uppercase m-2">{currentChannel.name}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {channelList && channelList.map((item, index) => {
                        return (
                            <Dropdown.Item key={item.channelGuid} onClick={() => changeChannel(item)}>{item.name}</Dropdown.Item>
                        )
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default DropdownButton;